import React from "react";
import { Box } from "@sproutsocial/seeds-react-box";
import { type TypeContentHeaderProps } from "./ContentHeaderTypes";
import { HeaderContainer } from "./ContentHeaderHybrid";
import { TitleArea } from "./TitleArea";

export const ContentHeader = ({
  title,
  subtitle,
  headingLevel = "h4",
  subtitleAs,
  leftSlot,
  rightSlot,
  rightTitleElement,
  headerActions,
  bordered = true,
}: TypeContentHeaderProps) => {
  return (
    <HeaderContainer bordered={bordered}>
      <TitleArea
        title={title}
        subtitle={subtitle}
        headingLevel={headingLevel}
        subtitleAs={subtitleAs}
        leftSlot={leftSlot}
        rightSlot={rightSlot}
        rightTitleElement={rightTitleElement}
      />
      {headerActions && <Box>{headerActions}</Box>}
    </HeaderContainer>
  );
};

export default ContentHeader;
